module.exports = __webpack_public_path__ + "img/default.b00ca915.png";